import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

type ToolTipProps = React.ComponentProps<typeof ReactTooltip>;

const Tooltip = function (props: ToolTipProps) {
    return (
        <ReactTooltip
            {...props}
            delayShow={550}
            className={`${props.className ?? ''}`}
            style={{
                "--rt-opacity": 1,
                backgroundColor: 'var(--color-sky-50)',
                color: 'var(--color-stone-800)',
                boxShadow: '0px 0px 15px 7px rgba(202,202,202,0.60)',
                borderRadius: '0.5rem',
                maxWidth: '20rem',
                ...props.style,
            } as React.CSSProperties}
        />
    );
};

export default Tooltip;